import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useBlocker } from 'react-router-dom';

const WarningForUnsavedChanges = ({
  when,
  message,
}) => {
  const alertUser = useCallback((e) => {
    if (when) {
      e.preventDefault();
      e.returnValue = '';
    }
  }, [when]);

  useEffect(() => {
    window.addEventListener('beforeunload', alertUser);
    return () => {
      window.removeEventListener('beforeunload', alertUser);
    };
  }, [alertUser]);

  useBlocker(() => {
    if (when) {
      return !window.confirm(message);
    }
    return false;
  });

  return (
    <div key={when} />
  );
};

WarningForUnsavedChanges.propTypes = {
  message: PropTypes.string.isRequired,
  when: PropTypes.bool.isRequired,
};

export default WarningForUnsavedChanges;
